import React, { Component } from 'react';
import AppUrl from '../../restApi/AppUrl';
import IRestClient from '../../restApi/IRestClient';
import ReactHtmlParser from 'react-html-parser';
import Wentwrong from '../Wentwrong/Wentwrong';
import { motion } from 'framer-motion';
import {
  FaHandHoldingHeart, FaUsers, FaMedkit, FaHome,
  FaSchool, FaUtensils, FaTools, FaUserGraduate,
  FaFutbol, FaFemale, FaAppleAlt, FaChild, FaBook,
  FaCheckCircle,
} from 'react-icons/fa';
import './Service.css';

// Mirrors CV_PALETTE from Aboutus — light bg + colored icon, no gradient fills
const SVC_PALETTE = [
  { accent: '#3DAA6B', light: '#E8F8EE' },
  { accent: '#1B2B5C', light: '#EEF1F9' },
  { accent: '#E8920A', light: '#FFF8E7' },
  { accent: '#2D4E96', light: '#E4EAF6' },
  { accent: '#237A4B', light: '#D4F0E1' },
  { accent: '#CC7B08', light: '#FEF0C2' },
];

const ICON_MAP = {
  FaHandHoldingHeart: <FaHandHoldingHeart />,
  FaUsers:            <FaUsers />,
  FaMedkit:           <FaMedkit />,
  FaHome:             <FaHome />,
  FaSchool:           <FaSchool />,
  FaUtensils:         <FaUtensils />,
  FaTools:            <FaTools />,
  FaUserGraduate:     <FaUserGraduate />,
  FaFutbol:           <FaFutbol />,
  FaFemale:           <FaFemale />,
  FaAppleAlt:         <FaAppleAlt />,
  FaChild:            <FaChild />,
  FaBook:             <FaBook />,
};

class Service extends Component {
  constructor(props) {
    super(props);
    this.state = { myData: [], error: false, loading: true };
  }

  componentDidMount() {
    IRestClient.GetRequest(AppUrl.Servicehome)
      .then(result => {
        if (result == null) this.setState({ error: true, loading: false });
        else               this.setState({ myData: result, loading: false });
      })
      .catch(() => this.setState({ error: true, loading: false }));
  }

  getIcon(name) {
    return ICON_MAP[name] || <FaHandHoldingHeart />;
  }

  renderSkeleton() {
    return (
      <section className="services-section py-16 sm:py-20">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10">
            <div className="svc-skel h-7 w-40 mx-auto mb-4 rounded-full" />
            <div className="svc-skel h-9 w-60 mx-auto mb-3 rounded-lg" />
            <div className="svc-skel h-3.5 w-72 mx-auto rounded" />
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5">
            {[1,2,3,4,5,6].map(i => (
              <div key={i} className="bg-white rounded-xl border border-neutral-100 p-4 sm:p-5 relative overflow-hidden">
                <div className="svc-skel absolute left-0 top-0 bottom-0 w-0.5" />
                <div className="svc-skel h-10 w-10 rounded-xl mb-3" />
                <div className="svc-skel h-4 w-3/5 mb-3 rounded" />
                <div className="svc-skel h-3 w-full mb-1.5 rounded" />
                <div className="svc-skel h-3 w-5/6 mb-1.5 rounded" />
                <div className="svc-skel h-3 w-4/6 mb-4 rounded" />
                <div className="svc-skel h-0.5 w-full rounded-full" />
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  render() {
    if (this.state.error)   return <Wentwrong />;
    if (this.state.loading) return this.renderSkeleton();

    const { myData } = this.state;

    return (
      <section className="services-section py-16 sm:py-20 overflow-hidden">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">

          {/* ── Section header — exact Core Values pattern ───────── */}
          <motion.div
            className="text-center mb-8 sm:mb-10"
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}>

            <motion.span
              className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-full mb-4"
              style={{ background: '#E8F8EE', color: '#237A4B', border: '1px solid #94DDB8' }}
              initial={{ opacity: 0, scale: 0.85 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.1 }}>
              <FaCheckCircle style={{ color: '#3DAA6B' }} />
              Our Services
            </motion.span>

            <h2 className="text-2xl sm:text-3xl font-black text-primary-900 leading-tight mb-2">
              How We{' '}
              <span style={{ color: '#3DAA6B' }}>Help</span>
            </h2>
            <p className="text-neutral-500 text-sm sm:text-base max-w-lg mx-auto leading-relaxed">
              Comprehensive programs built to empower people, strengthen families,
              and create lasting change across the region.
            </p>

            {/* Animated width underline — same as Core Values */}
            <motion.div
              className="mx-auto mt-4 h-0.5 rounded-full"
              style={{ background: 'linear-gradient(90deg,#3DAA6B,#1B2B5C)', width: 0 }}
              whileInView={{ width: 64 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.3 }}
            />
          </motion.div>

          {/* ── Cards grid ──────────────────────────────────────── */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5">
            {myData.map((service, index) => {
              const pal = SVC_PALETTE[index % SVC_PALETTE.length];
              // Even → slide from left, odd → slide from right (Core Values feel)
              const fromX = index % 2 === 0 ? -30 : 30;

              return (
                <motion.div
                  key={index}
                  className="group relative bg-white rounded-xl border overflow-hidden cursor-default"
                  style={{ borderColor: '#f1f5f9', boxShadow: '0 2px 6px rgba(0,0,0,0.04)' }}
                  initial={{ opacity: 0, x: fromX }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: index * 0.08, ease: 'easeOut' }}
                  whileHover={{
                    y: -2,
                    boxShadow: `0 10px 28px ${pal.accent}18`,
                    borderColor: `${pal.accent}33`,
                    transition: { duration: 0.2 },
                  }}>

                  {/* Left accent bar — scaleY 0→1 on scroll (Objectives pattern) */}
                  <motion.div
                    className="absolute left-0 top-0 bottom-0 w-0.5 rounded-l-xl"
                    style={{
                      background: `linear-gradient(180deg,${pal.accent},${pal.accent}55)`,
                      scaleY: 0,
                      originY: 0,
                    }}
                    whileInView={{ scaleY: 1 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.55, delay: index * 0.08 + 0.2 }}
                  />

                  {/* Ghost number — exact Objectives pattern */}
                  <span
                    className="absolute right-3 top-1 select-none pointer-events-none font-black leading-none"
                    style={{
                      fontSize: 'clamp(2.8rem,7vw,4rem)',
                      color: '#1B2B5C',
                      opacity: 0.04,
                      letterSpacing: '-0.04em',
                    }}
                    aria-hidden="true">
                    {String(index + 1).padStart(2, '0')}
                  </span>

                  <div className="p-4 sm:p-5 relative">

                    {/* Icon badge — Core Values style: light bg + colored icon + whileHover wiggle */}
                    <motion.div
                      className="w-10 h-10 sm:w-11 sm:h-11 rounded-xl flex items-center justify-center mb-3 shadow-sm"
                      style={{
                        background: pal.light,
                        border: `2px solid ${pal.accent}22`,
                        color: pal.accent,
                        fontSize: '1.1rem',
                      }}
                      whileHover={{
                        rotate: [0, -5, 5, 0],
                        scale: 1.12,
                        transition: { duration: 0.35 },
                      }}>
                      {this.getIcon(service.service_faicon)}
                    </motion.div>

                    {/* Title */}
                    <div className="flex items-center gap-2 mb-1.5">
                      <span
                        className="text-xs font-black uppercase tracking-widest px-2 py-0.5 rounded-full"
                        style={{ background: `${pal.accent}15`, color: pal.accent }}>
                        {String(index + 1).padStart(2, '0')}.
                      </span>
                      <h3
                        className="text-sm sm:text-base font-bold text-primary-900 leading-snug"
                        style={{ paddingRight: '20px' }}>
                        {service.service_title}
                      </h3>
                    </div>

                    {/* Description — CSS 3-line clamp */}
                    <div className="svc-desc text-xs sm:text-sm text-neutral-500 leading-relaxed mb-3">
                      {ReactHtmlParser(service.service_shortdescription || '')}
                    </div>

                    {/* Animated bottom gradient line — Core Values pattern */}
                    <motion.div
                      className="h-0.5 rounded-full"
                      style={{
                        background: `linear-gradient(90deg,${pal.accent},transparent)`,
                        originX: 0,
                      }}
                      initial={{ scaleX: 0 }}
                      whileInView={{ scaleX: 1 }}
                      viewport={{ once: true }}
                      transition={{ duration: 0.55, delay: index * 0.08 + 0.3 }}
                    />
                  </div>
                </motion.div>
              );
            })}
          </div>

        </div>
      </section>
    );
  }
}

export default Service;
